import { Button } from '../components/Button'
import { Screen } from '../components/Screen'
import { t } from '../i18n'

export function ErrorScreen({
  message,
  code,
  onRetry,
  onClose,
}: {
  message: string
  /** The §13.8 code, when the failure had one. */
  code?: string | null
  onRetry?: () => void
  onClose?: () => void
}) {
  return (
    <Screen onClose={onClose}>
      <div className="flex flex-col gap-4 text-center">
        <h1 className="text-lg font-semibold text-red-600">{t('somethingWrong')}</h1>
        <p className="text-slate-600">{message}</p>
        {/* Selectable on purpose: the copy asks the cashier to report this, and anyone
         * reading an identifier off an iPad to a support line will get it wrong. Kept as
         * its own element rather than folded into the sentence so it can be copied. */}
        {code ? (
          <code className="select-all break-all text-[13px] text-slate-400">{code}</code>
        ) : null}
        {onRetry && (
          <Button variant="secondary" onClick={onRetry}>
            {t('tryAgain')}
          </Button>
        )}
      </div>
    </Screen>
  )
}
